import 'virtual:svg-icons-register'

import { addCollection } from '@iconify/vue'
import epIcons from '@iconify/json/json/ep.json'
import faIcons from '@iconify/json/json/fa.json'
import faSolidIcons from '@iconify/json/json/fa-solid.json'

addCollection(epIcons)
addCollection(faIcons)
addCollection(faSolidIcons)
